import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import { capitalizeFirstLetter } from 'utils/general';
import DATA_CY from 'constants/data-cy';

interface NotificationTitleProps {
  tab?: string;
  onClickBack?: () => void;
}

function NotificationTitle({ tab, onClickBack }: NotificationTitleProps) {
  const TAB = capitalizeFirstLetter(tab);

  if (tab !== 'notification') {
    return (
      <Flex align="center">
        <IconWrapper
          key="icon-notification_back"
          // @ts-expect-error
          margin="0 0 0 -16px"
          onClick={onClickBack}
        >
          <Iconmoon size="30px" className="icon-notification_back" />
        </IconWrapper>
        <Text
          family="bold"
          size="16px"
          data-cy={`${DATA_CY.NOTIFICATION.TITLE_TEXT}-${TAB}`}
        >
          {TAB}
        </Text>
      </Flex>
    );
  }

  return (
    <Text
      family="bold"
      size="16px"
      data-cy={`${DATA_CY.NOTIFICATION.TITLE_TEXT}-Notification`}
    >
      {TAB}
    </Text>
  );
}
export default NotificationTitle;
